import React from 'react'

import { connect } from 'react-redux'
import { appCreateRequest } from '../../actions'

import { Form, FormSection } from 'components/Form'
import { Button } from 'components/Button'

import { appNameValidator } from './validators.js'
import FieldSection from './FieldSection.js'
import { TEXT, SELECT } from './fieldTypes.js'

import { reduxForm } from 'redux-form'

const CreateNewAppForm = props => {
	const { dispatchSubmit, handleSubmit, submitting } = props
	const fields = [
		{
			type: TEXT,
			name: 'appName',
			fieldId: 'appName',
			title: 'App Name',
			description:
				'We like cool names, but "asdf" will work for now. You can always change it later.',
			placeholder: 'Watermelon app',
			validate: appNameValidator,
			autofocus: true,
			required: true
		},
		{
			type: SELECT,
			name: 'appType',
			fieldId: 'appType',
			title: 'App type',
			description: (
				<div>
					This refers to the OAuth2.0 authorization flow. If you are
					building an app running in the browser, go for{' '}
					<a
						href={
							process.env.REACT_APP_DEV_DOCS_URL +
							'/authorization/#public-web-apps'
						}
						target="_blank"
						rel="noopener"
					>
						web app
					</a>. If you're going to build something that runs on the
					server, you'll need to create a{' '}
					<a
						href={
							process.env.REACT_APP_DEV_DOCS_URL +
							'/authorization/#public-server-side-apps'
						}
						target="_blank"
						rel="noopener"
					>
						server-side app
					</a>.
				</div>
			),
			options: [
				{
					value: 'chatio',
					label: 'Web app (frontend, eg. JavaScript)'
				},
				{
					value: 'chatio-backend',
					label: 'Server-side app (backend, eg. Node, PHP)'
				}
			],
			placeholder: 'JavaScript App',
			validate: appNameValidator,
			required: true
		}
	]

	return (
		<Form handleSubmit={handleSubmit(dispatchSubmit)}>
			{fields.map(field => {
				return <FieldSection {...field} key={field.fieldId} />
			})}

			<FormSection right>
				<Button
					icon="navigate_next"
					htmlType="submit"
					loading={submitting}
					disabled={submitting}
				>
					{'Continue'}
				</Button>
			</FormSection>
		</Form>
	)
}

const mapStateToProps = (state, ownProps) => ({
	initialValues: { appType: 'chatio' }
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	dispatchSubmit: values => {
		dispatch(
			appCreateRequest({
				name: values.appName,
				type: values.appType,
				formName: 'createNewApp',
				handleClose: ownProps.closePortal
			})
		)
	}
})

const ConnectedCreateNewAppForm = connect(mapStateToProps, mapDispatchToProps)(
	reduxForm({ form: 'createNewApp', touchOnBlur: false })(CreateNewAppForm)
)

export default ConnectedCreateNewAppForm



// WEBPACK FOOTER //
// ./src/containers/Forms/CreateNewAppForm.js